<template>
  <IconButton class="rounded-l-none!" icon="refresh" :icon-class="refreshing ? 'animate-spin-once' : ''" @click="handleClick"></IconButton>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  refresh: [];
}>();

const refreshing = ref<boolean>(false);

const handleClick = (): void => {
  emit("refresh");
  refreshing.value = true;
  setTimeout(() => {
    refreshing.value = false;
  }, 300);
};
</script>
